import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Container, Typography, Box, Button, Grid } from "@mui/material";

function KeybordPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [inputText, setInputText] = useState("");

  // ログイン状態チェック
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { state: { from: '/keybord' }, replace: true });
    }
  }, [isAuthenticated, navigate]);

  // ログイン中のみ表示
  if (!isAuthenticated) {
    return null; // リダイレクト中は何も表示しない
  }

  const qwertyKeys = [
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm']
  ];

  const handleKeyPress = (key) => {
    setInputText(prev => prev + key);
  };

  const handleDelete = () => {
    setInputText(prev => prev.slice(0, -1));
  };

  const handleClear = () => {
    setInputText("");
  };

  return (
    <Container maxWidth={false} sx={{ paddingTop: 4, paddingBottom: 4, width: '100%', px: 1 }}>
      <Typography 
        variant="h4" 
        component="h1" 
        align="center" 
        gutterBottom
        sx={{ marginBottom: 4 }}
      >
        キーボード実験ページ
      </Typography>

      <Box sx={{ textAlign: 'center', marginBottom: 4 }}>
        <Typography 
          variant="h6" 
          component="div" 
          sx={{ 
            borderBottom: '2px solid #000',
            paddingBottom: 1,
            minHeight: '2rem',
            fontSize: '1.5rem',
            fontFamily: 'monospace',
            textAlign: 'left',
            width: '100%',
            margin: '0 auto'
          }}
        >
          {inputText || '\u00A0'}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <Box sx={{ display: 'flex', gap: 1, marginBottom: 2 }}>
          <Button
            variant="contained"
            color="warning"
            onClick={handleDelete}
            sx={{ 
              minWidth: { xs: '60px', sm: '80px' }, 
              height: { xs: '36px', sm: '40px' },
              fontSize: { xs: '0.8rem', sm: '1rem' }
            }}
          >
            削除
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleClear}
            sx={{ 
              minWidth: { xs: '60px', sm: '80px' }, 
              height: { xs: '36px', sm: '40px' },
              fontSize: { xs: '0.8rem', sm: '1rem' }
            }}
          >
            全削除
          </Button>
        </Box>

        {qwertyKeys.map((row, rowIndex) => (
          <Box key={rowIndex} sx={{ display: 'flex', gap: { xs: 0.3, sm: 1 }, justifyContent: 'center', width: '100%' }}>
            {row.map((key) => (
              <Button
                key={key}
                variant="outlined"
                onClick={() => handleKeyPress(key)}
                sx={{
                  width: 'calc(10% - 2.7px)',
                  minWidth: { xs: '26px' },
                  height: { xs: '36px', sm: '40px' },
                  fontSize: { xs: '0.9rem', sm: '1.2rem' },
                  fontWeight: 'bold',
                  px: { xs: 0.5, sm: 1 },
                  textTransform: 'none'
                }}
              >
                {key}
              </Button>
            ))}
          </Box>
        ))}
      </Box>
    </Container>
  );
}

export default KeybordPage;